const API_ORIGIN = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/api$/, '');

/**
 * Converts a raw coverImage value from the database into a usable absolute URL.
 * Returns null if no image is set (component will show the gradient placeholder).
 */
export const getBookCover = (url) => {
  if (!url) return null;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/uploads/')) return `${API_ORIGIN}${url}`;
  return null;
};

export default getBookCover;
